import React from "react";

const WhyChooseUs = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.title}>Why Choose <span style={styles.brand}>L’ARTISAN</span>?</h2>
        <p style={styles.subtitle}>
          Because every piece we craft tells a story of passion, precision, and timeless beauty.
        </p>

        <div style={styles.cardsContainer}>
          <div style={styles.card}>
            <div style={styles.icon}>🏺</div>
            <h3 style={styles.cardTitle}>Natural Materials</h3>
            <p style={styles.cardText}>
              We use only premium-quality wood and eco-friendly finishes to create sustainable art.
            </p>
          </div>

          <div style={styles.card}>
            <div style={styles.icon}>🎨</div>
            <h3 style={styles.cardTitle}>Handcrafted Designs</h3>
            <p style={styles.cardText}>
              Each product is handmade with love, blending traditional artistry and modern taste.
            </p>
          </div>

          <div style={styles.card}>
            <div style={styles.icon}>🏡</div>
            <h3 style={styles.cardTitle}>Timeless Home Décor</h3>
            <p style={styles.cardText}>
              Our creations bring warmth, elegance, and soul to every corner of your home.
            </p>
          </div>

          <div style={styles.card}>
            <div style={styles.icon}>🇪🇬</div>
            <h3 style={styles.cardTitle}>Made in Egypt</h3>
            <p style={styles.cardText}>
              Proudly crafted by Egyptian artisans who turn wood into heritage-inspired art.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: "#fdfaf6",
    padding: "80px 20px",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    textAlign: "center",
  },
  title: {
    fontSize: "36px",
    marginBottom: "10px",
    color: "#3e2f22", // بني داكن
    fontFamily: "serif",
  },
  brand: {
    color: "#6b7a3c", // زيتوني
  },
  subtitle: {
    color: "#5a5a5a",
    fontSize: "18px",
    marginBottom: "50px",
  },
  cardsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "30px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "30px 20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  icon: {
    fontSize: "40px",
    marginBottom: "15px",
  },
  cardTitle: {
    color: "#3e2f22",
    fontSize: "20px",
    marginBottom: "10px",
  },
  cardText: {
    color: "#555",
    fontSize: "16px",
    lineHeight: "1.6",
  },
};

export default WhyChooseUs;
